$('#goToPage').on('change', function() {
	window.location = this.value;
});
